import { render, staticRenderFns } from "./ObjectiveEffects.vue?vue&type=template&id=0a7ed5e7&"
import script from "./ObjectiveEffects.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports